import * as ActionTypes from '../ActionTypes';


export const GetAttendanceCodeAction = (params, callback) => ({
    type: ActionTypes.GET_ATTENDANCE_CODE_REQUEST,
    params,
    callback
});

export const AddAttendanceCodeAction = (params,callback) => ({
    type: ActionTypes.UPDATE_ATTENDANCE_CODE_REQUEST,
    params,
    callback
});

export const DeleteAttendanceCodeAction = (params,callback) => ({
    type: ActionTypes.DELETE_ATTENDANCE_CODE_REQUEST,
    params,
    callback
});